<div class="custom-modal-container">
  <div class="form-wrapper custom-modal-container-content {{ context.classes ? context.classes : '' }}">
    <div (click)="onClose()" class="close-button" *ngIf="context && !context.isClose">
      <svg class="icon-svg">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#dialog-cross"></use>
      </svg>
    </div>
    <div class="modal-icon-wrap" [ngClass]="{ done: context.status }">
      <div class="modal-icon">
        <svg class="icon-svg">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" [attr.xlink:href]="context.svg.xlinkHref"></use>
        </svg>
      </div>
    </div>
    <div class="content-container">
      <h2 class="modal-title" *ngIf="context && context.title">{{ context.title | translate }}</h2>
      <p class="modal-paragraph" *ngIf="context && context.description">{{ context.description | translate }}</p>
      <div class="field-container" *ngIf="context && context.fields">
        <div *ngFor="let field of context.fields">
          <!--<label class="modal-label" [ngClass]="{'error' : field.isError}">{{field.title | translate}}</label>-->
          <label class="modal-field-wrap" [ngClass]="{ required: field.isRequired }" *ngIf="fieldTypes.Input === field.type">
            <input
              class="modal-field"
              [ngClass]="{ error: field.isError }"
              type="text"
              name=""
              [value]="field.value"
              (input)="enter(field, $event.target.value)"
            />
            <span class="modal-field-fake-placeholder" [ngClass]="{ 'full-field': field.value }">{{ field.placeholder | translate }}</span>
            <span class="required-text" *ngIf="field.isRequired">{{ 'Required*' | translate }}</span>
          </label>
          <label class="modal-field-wrap" [ngClass]="{ required: field.isRequired }" *ngIf="fieldTypes.Textarea === field.type">
            <textarea
              class="modal-field"
              [ngClass]="{ error: field.isError || field.value.length === 140 }"
              type="textarea"
              maxlength="140"
              name=""
              [value]="field.value"
              (input)="enter(field, $event.target.value)"
            >
            </textarea>
            <span class="modal-field-fake-placeholder" [ngClass]="{ 'full-field': field.value }">
              <span class="modal-field-fake-text">{{ field.placeholder | translate }}</span>
            </span>
            <div class="required-text-wrap">
              <span class="required-text">{{ 'Required*' | translate }}</span>
              <span class="required-text required-text-counter">{{ field.value.length }} / 140</span>
            </div>
          </label>
        </div>
      </div>
      <div class="apply-btn-wrap {{ context.buttonsClass }}">
        <a
          class="apply-btn  {{ button.classes }}"
          [ngClass]="{ disabled: context && context.buttons && button.type !== 'cancel' && !isValidate }"
          *ngFor="let button of context.buttons"
          (click)="onClick(button)"
          >{{ button.text | translate }}</a
        >
      </div>
    </div>
  </div>
</div>
